enum Type {
  WITHDRAW = "WITHDRAW",
  DEPOSIT = "DEPOSIT",
}

export default Type;
